module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Ormalingen-1faacbc680aab76a7ac80775dc902a14.svg";